<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="content">
                <ul class="list-item cle">
                    <li class="item-ele fl" v-text="sharer" :title="sharer"></li>
                    <li class="item-ele-tag fl">:</li>
                    <li class="item-ele-txt fl" v-text="sharername" :title="sharername"></li>
                </ul>
                <ul class="list-item cle">
                    <li class="item-ele fl" v-text="shareDevice" :title="shareDevice"></li>
                    <li class="item-ele-tag fl">:</li>
                    <li class="item-ele-txt fl" v-text="devicename" :title="devicename"></li>
                </ul>
                <div class="remind-txt">
                    <span v-text="text" class="remindTip"></span>
                </div>
            </div>
            <div class="user-mes-btn cle" style="margin-top:10px;">
                <button type="button" class="fl" @click="acSet(0)" :title="ignore" v-text="ignore"></button>
                <button type="button" class="fr" @click="acSet(1)" :title="accept" v-text="accept"></button>
            </div>
        </div>
    </div>
</template>
<script>
import share from '../assets/js/share.js'
export default {
    name:'ShareRemind',
    data(){
        return{
            mes:[],
            sharer:this.lanNow.lan['K218_Share'],
            shareDevice:this.lanNow.lan['K023_DeviceName'],
            text:this.lanNow.lan['K190_Remind'],
            result:'',
            ignore:this.lanNow.lan['K191_Ignore'],
            accept:this.lanNow.lan['K192_Accept'],
            id:'',
            name:'',
            sharername:'',
            devicename:'',
            isHs:0
        }
    },
    methods:{
        getMes:function(arr){
            this.mes=arr.concat([]);
            this.render();
        },
        render:function(){
            var obj=this.mes[0];
            // this.result=this.text.replace('baidu',obj.user).replace('google',obj.name);
            this.sharername=obj.user;
            this.devicename=obj.name;
            this.id=obj.id;
            this.name=obj.name;
            this.isHs=obj.isHs;
        },
        acSet:function(isAccept){
            this.ajaxH.repeat=function(){
                this.acSetAfter(isAccept);
            }.bind(this);
            this.$emit('refresh');
        },
        acSetAfter:function(isAccept){
            var str=share.acceptDevice({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem,
                id:this.id,
                name:this.name,
                isHs:this.isHs,
                accept:isAccept
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.acSetResult(data.data);
        },
        acSetResult:function(data){
            var result=$(data).find('header').find('result').text()-0;
            this.$emit('refresh');
            this.mes.shift();
            this.mes.length&&this.render();
            this.mes.length===0&&this.cancel();
        },
        cancel:function(){
            this.$emit('close');
            setTimeout(function(){
                this.$emit('reRemind',true);
            }.bind(this),2000);
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:300px;
        height:auto;
        padding:20px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        left:50%;
        margin-top:160px;
        margin-left:-150px;
        box-sizing: border-box;
    }
    .content{
        width:100%;
        height:120px;
    }
    .list-item{
        width:100%;
        height:24px;
        line-height: 24px;
    }
    .item-ele{
        max-width:120px;
        width:auto;
        height:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .item-ele-tag{
        width:10px;
        height:100%;
        text-align: center;
    }
    .item-ele-txt{
        max-width:calc(100% - 130px);
        width:auto;
        height:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .list-item+.list-item{
        margin-top:10px;
    }
    .remind-txt{
        width:100%;
        height:calc(100% - 68px);
        margin-top: 10px;
        /* font-size: 18px; */
        word-wrap:break-word;
        word-break: break-all;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>


// WEBPACK FOOTER //
// src/components/ShareRemind.vue